import { render, staticRenderFns } from "./text-block.datagrid.vue?vue&type=template&id=5dae549e&scoped=true&"
import script from "./text-block.datagrid.vue?vue&type=script&lang=js&"
export * from "./text-block.datagrid.vue?vue&type=script&lang=js&"
import style0 from "./text-block.datagrid.vue?vue&type=style&index=0&id=5dae549e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae549e",
  null
  
)

export default component.exports